import React from "react";

import { Button } from "components/ui/Button";

import s from "./CardWithTitle.module.css";

const CardWithTitle = ({
  children,
  title,
  titleAddon,
  endIcon,
  minWidth,
  buttonTitle,
  onButtonClick,
  marginBottom,
  paddingBottom,
  className,
  buttonVariant = "text",
  endContent,
}) => {
  return (
    <div style={{ minWidth: minWidth }} className={s.cardWrapper}>
      <div
        style={{ marginBottom: marginBottom, paddingBottom: paddingBottom }}
        className={s.topWrapper}
      >
        <div className={s.titleWrapper}>
          <h3 className={s.title}>{title}</h3>
          {titleAddon}
        </div>
        {endContent ?? (buttonTitle && (
          <Button
            variant={buttonVariant}
            onClick={onButtonClick}
            className={className}
            endIcon={endIcon}
          >
            {buttonTitle}
          </Button>
        ))}
      </div>
      {children}
    </div>
  );
};

export { CardWithTitle };
